<template>
    <div>
        <label v-if="label" class="vs-input--label" :for="`${_uid}-input`" v-html="label_text" />
        <!-- @click="focusInput" -->
        <div
            ref="group"
            class="unit-input flex flex-nowrap"
            :class="{
                'active': focused,
                'has-validation-errors': hasValidationErrors,
                'has-prepend': hasPrependedOptions,
                'has-append': hasAppendedOptions
            }"
        >
            <div v-if="hasPrependedOptions" class="unit-dropdown-wrapper self-start">
                <div
                    v-if="staticUnit"
                    class="w-full static-unit"
                    :class="{
                        active: focused
                    }"
                    @click="staticUnitClicked"
                >
                    <span v-html="staticUnit"> </span>
                </div>
                <vx-select
                    v-else
                    v-model="localPrependUnit"
                    :disabled="disabled"
                    ref="selector"
                    remove-validation-padding
                    class="unit-select"
                    :options="prependUnitOptions"
                    @focus.prevent="selectFocused"
                    @blur.prevent="selectBlurred"
                    @input="unitSelected"
                />
            </div>
            <vx-input
                ref="input"
                v-model="localValue"
                v-bind="$attrs"
                remove-validation-padding
                :disabled="disabled"
                :name="name"
                class="value-input"
                :class="{
                    'self-end': !!prependUnitOptions
                }"
                @focus.prevent="inputFocused"
                @blur.prevent="inputBlurred"
            />
            <div v-if="hasAppendedOptions" class="unit-dropdown-wrapper self-start">
                <div
                    v-if="staticUnit"
                    class="w-full static-unit"
                    :class="{
                        active: focused
                    }"
                    @click="staticUnitClicked"
                >
                    <span v-html="staticUnit"> </span>
                </div>
                <vx-select
                    v-else
                    v-model="localUnit"
                    :disabled="disabled"
                    ref="selector"
                    remove-validation-padding
                    class="unit-select"
                    :options="unitOptions"
                    @focus.prevent="selectFocused"
                    @blur.prevent="selectBlurred"
                    @input="unitSelected"
                />
            </div>
        </div>
        <vx-validation-message />
    </div>
</template>

<script>
import ValidationMixins from '@/plugins/validation/mixins'

export default {
    name: 'vx-unit-input',
    mixins: [ValidationMixins],
    props: {
        value: {
            type: [Number, String]
        },
        label: {
            type: String
        },
        disabled: {
            type: Boolean,
            default: false
        },
        name: {
            type: String
        },
        unitOptions: {
            type: [Array, String]
        },
        unit: {
            type: String
        },
        danger: {
            type: Boolean
        },
        prependUnitOptions: {
            type: [Array, String]
        },
        prependUnit: {
            type: String
        }
    },
    watch: {
        focused(val) {
            this.$emit(val ? 'focus' : 'blur')
        }
    },
    data() {
        return {
            selectHasFocus: false,
            inputHasFocus: false
        }
    },
    computed: {
        localValue: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        },
        localUnit: {
            get() {
                return this.unit
            },
            set(val) {
                this.$emit('update:unit', val)
            }
        },
        localPrependUnit: {
            get() {
                return this.prependUnit
            },
            set(val) {
                this.$emit('update:prepend-unit', val)
            }
        },
        hasPrependedOptions() {
            if (Array.isArray(this.prependUnitOptions)) {
                return this.prependUnitOptions && this.prependUnitOptions.any()
            }
            return false
        },
        hasAppendedOptions() {
            if (Array.isArray(this.unitOptions)) {
                return this.unitOptions && this.unitOptions.any()
            }
            return !!this.staticUnit
        },
        focused: {
            get() {
                return this.inputHasFocus || this.selectHasFocus
            },
            set(val) {
                this.inputHasFocus = val
                this.selectHasFocus = val
            }
        },
        staticUnit() {
            if (!Array.isArray(this.unitOptions)) {
                return this.unitOptions
            }

            if (this.unitOptions.length === 1) {
                return this.unitOptions.first()
            }
            return null
        },
        input() {
            return this.$refs.input
        },
        select() {
            return this.$refs.selector
        }
    },
    methods: {
        staticUnitClicked() {
            this.input.$el.focus()
        },
        inputBlurred(e) {
            this.inputHasFocus = false
            this.$emit('input-blurred', e)
        },
        inputFocused(e) {
            if (!this.staticUnit && this.select) {
                this.select.close()
            }
            this.inputHasFocus = true
            this.selectHasFocus = false
            this.$emit('input-focused', e)
        },
        selectBlurred(e) {
            if (e.relatedTarget ? !e.relatedTarget.closest('.vs-select--options') : false) {
                this.selectHasFocus = false
                this.$emit('select-blurred')
            }
        },
        unitSelected(e) {
            this.selectHasFocus = false
            this.$emit('select-blurred')
        },
        selectFocused(e) {
            this.selectHasFocus = true
            this.inputHasFocus = false
            this.$emit('select-focused', e)
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/vuexy/_variables.scss';

.unit-input {
    font-family: Montserrat, Helvetica, Arial, sans-serif;

    .value-input {
        flex-grow: 1;
    }

    &.has-prepend {
        ::v-deep input {
            border-left: none;
        }
    }
    &.has-append {
        ::v-deep input {
            border-right: none;
        }
    }
    ::v-deep input {
        height: 37.59px;
    }

    &.has-validation-errors {
        .static-unit {
            background-color: rgba(var(--vs-danger), 1) !important;
        }
        ::v-deep input {
            border-color: $danger !important;
        }
        .unit-select {
            ::v-deep input {
                background-color: $danger !important;
            }
        }
    }

    .vs-input >>> .input-icon-validate {
        display: none;
    }

    .unit-select {
        ::v-deep input {
            border: none !important;
            background-color: $primary !important;
            color: $dark-grey !important;
        }
        ::v-deep i {
            color: $dark-grey;
        }
    }

    &.active {
        .static-unit {
            box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
        }

        ::v-deep input {
            border-color: 1px solid $primary;
            box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
        }
    }
}

.unit-dropdown-wrapper {
    // width: fit-content;
    max-width: 40%;
    // flex-shrink: 1;
    // width: 70px;
    transition: all 0.3s ease;

    &.self-end {
        ::v-deep input {
            border-left: 0px;
        }
    }
    &.self-start {
        ::v-deep input {
            border-right: 0px;
        }
    }
}

.static-unit {
    display: flex;
    justify-items: center;
    align-items: center;
    height: 37.59px;
    letter-spacing: normal;
    font-family: system-ui;
    background-color: rgba(var(--vs-primary), 1) !important;
    user-select: none;

    span {
        padding-left: 10px;
        padding-right: 10px;
    }
}
</style>
